import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { Injectable } from '@angular/core';
import {
  ApiParams,
  ApiParamsAlterate,
  QuotationParamsDTO
} from '@core/modules/api/models';

@Injectable({
  providedIn: 'root'
})
export class InputAdapterCustomService extends InputAdapterService {
  constructor() {
    super();
  }

  postQuotations(
    params: ApiParams<void, QuotationParamsDTO>
  ): ApiParamsAlterate<void> {
    return {
      ...params,
      body: {
        productCode: params.body.productCode,
        loanPurpose: params.body.finality,
        requestedAmount: params.body.amount,
        installment: params.body.installment,
        duration: params.body.duration
      }
    };
  }
}
